import { handleActions } from 'redux-actions';
import update from 'immutability-helper';

import {
	GET_PERSONAL_PAYROLL_CALL,
	GET_PERSONAL_PAYROLL_DONE,
	GET_PERSONAL_PAYROLL_FAIL,
} from '@src/store/types';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	// fake data
	personalPayrollList: [{
		id: '1',
		type: '薪資',
		name: '4 月薪資',
		date: '2025-04-01',
		start: '2025-04-01',
		end: '2025-04-30',
		payday: '2025-05-05',
	}],
	getPersonalPayrollListSideEffect: defaultSideEffectState,
};

export default handleActions({
	[GET_PERSONAL_PAYROLL_CALL](state) {
		return update(state, {
			getPersonalPayrollListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PERSONAL_PAYROLL_DONE](state, { payload: { res } }) {
		return update(state, {
			personalPayrollList: { $set: res },
			getPersonalPayrollListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PERSONAL_PAYROLL_FAIL](state, { payload }) {
		return update(state, {
			getPersonalPayrollListSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
}, initialState);
